import { BodyText } from '@calendly/ui/components/typography'

import { useI18n } from 'locales'

import MicrosoftIcon from '../assets/microsoft.svg'
import { SignupButtonLogo } from '../styles'

import { OmniAuthButton } from './omniauth_button'

export const MicrosoftSignUpButton = () => {
  const { i18n } = useI18n()
  return (
    <OmniAuthButton provider="azure2_oauth2" email="">
      <SignupButtonLogo src={MicrosoftIcon} alt="Microsoft" />
      <BodyText size="medium">{i18n.t('booking.templates.signup_form.sign_up_with_microsoft')}</BodyText>
    </OmniAuthButton>
  )
}
